// Training module data - Durugörü Eğitim Programı
export const trainingModules = [
  {
    id: 1,
    title: 'Sezgisel Algının Temelleri',
    description: 'Psişik algının temellerini öğrenin. Sezgisel sinyalleri tanıma ve güvenme becerilerinizi geliştirin.',
    duration: '45 dk'
  },
  {
    id: 2,
    title: 'Üçüncü Göz Açma',
    description: 'Ajna çakrasını aktive edin. 3. göz meditasyonları ve pineal bez uyandırma teknikleri.',
    duration: '55 dk'
  },
  {
    id: 3,
    title: 'Zener Tabanlı Pratik',
    description: 'Zener kartları ile sistematik pratik yapın. Sembol algılama ve sezgisel odaklanma egzersizleri.',
    duration: '40 dk'
  },
  {
    id: 4,
    title: 'Diğer Duru Sesi Yeteneklerini Aktive Etmek',
    description: 'Telepati, önsezi ve uzaktan görme gibi diğer psişik yeteneklerinizi keşfedin ve geliştirin.',
    duration: '60 dk'
  },
  {
    id: 5,
    title: 'İleri Seviye Durugörü Pratikleri',
    description: 'Uzman seviyesi teknikler. Enerji okuma, astral projeksiyon ve gelişmiş algı çalışmaları.',
    duration: '52 dk'
  }
];
